import { Component } from '@angular/core';

import { Platform, NavController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AlertService } from 'src/services/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private alertService: AlertService,
    private router: Router,
    private navCtrl: NavController
  ) {
    this.initializeApp();
    this.backbutton();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.statusBar.styleLightContent();

        this.statusBar.overlaysWebView(false);
        this.statusBar.backgroundColorByHexString('#fff');
      }
      this.splashScreen.hide();
    });
  }

  lastTimeBackPress = 0;
  timePeriodToExit = 2000;

  backbutton() {
    this.platform.backButton.subscribeWithPriority(0, async () => {
      let url = this.router.url;

      switch (url) {
        case '/tabs':
        case '/tabs/home':
        case '/tabs/search':
        case '/tabs/my-estimate-list':
        case '/tabs/my-estimate':
        case '/tabs/setting-my':
        case '/tabs/setting': {
          if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
            navigator['app'].exitApp();
          } else {
            this.alertService.presentToast('다시 한번 누르면 종료됩니다.');
            this.lastTimeBackPress = new Date().getTime();
          }
          break;
        }

        default: {
          this.navCtrl.pop();
          break;
        }
      }
    });
  }

  // ionViewWillEnter() {
  //   this.resume = this.platform.resume.subscribe(() => {
  //     this.db.updateAt(`teacher/${localStorage.getItem('userId')}`, { chatOn: this.chatUser });
  //   });
  //   this.pause = this.platform.pause.subscribe(() => {
  //     this.db.updateAt(`teacher/${localStorage.getItem('userId')}`, { chatOn: '' });
  //   });
  //   this.db.updateAt(`teacher/${localStorage.getItem('userId')}`, { chatOn: this.chatUser });
  // }

  // ionViewWillLeave(): void {
  //   this.db.updateAt(`teacher/${localStorage.getItem('userId')}`, { chatOn: '' });

  //   this.resume.unsubscribe();
  //   this.pause.unsubscribe();
  // }
}
